// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__AbZ78","wrapper":"Footer_wrapper__1C_mQ","row":"Footer_row__8eSWp","row-box":"Footer_row-box__5gHgR","app-container":"Footer_app-container__rH9BH"};